import { useLoaderData, useParams } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { SubscriptionActionDetailsView } from '../../../../../components/SubscriptionActionDetails/SubscriptionActionDetailsView.js';
import type { RequestId } from '../../../../../common/constants/pathInterfaces.js';
import type { SubscriptionActionsResponse } from '../../../../../generated/api/subscriptionActionsResponse';

export const EoeChangeRequestPath = () => {
  const { requestId } = useParams<RequestId>();
  const { subscriptionActions } = useLoaderData() as SubscriptionActionsResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg)]);

  return (
    <SubscriptionActionDetailsView
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.Y29L(orderRequestsMsg), path: paths.EMPLOYEE_CHANGE_REQUEST_ORDERS },
        { name: `${requestId}` },
      ]}
      subscriptionAction={subscriptionActions[0]}
      isEoe={true}
    />
  );
};
